export default __webpack_public_path__ + "static/media/Backgound-IMG_xmall.1be6fea5.jpg";